<script lang="ts" setup>
//types
import type { Product } from '../type';

//components
import ProductCard from './ProductCard.vue';
import ProductSkeletons from './ProductSkeletons.vue';
import Observer from '@/core/components/essenstials/Observer.vue';

//composable
import { useInfiniteScroll } from '../composable/useInfiniteScroll';
import { useProductPickerStore } from '../composable/useProductPickerStore';

//hooks
const { isFetchMore, isFetchMoreQuery } = useInfiniteScroll();
const { fetchProducts, productsList, queryList, query, isMessage } = useProductPickerStore();

//computed
const products = computed(() => {
  if (query.value?.length > 0) {
    return queryList.value;
  }
  return productsList.value;
});
</script>

<template>
  <div class="product-list overflow-auto rounded-t-[3px] pl-2 pr-1" :class="{ 'is-full-height': !isMessage }">
    <div class="relative rounded-[3px] bg-white">
      <div class="body-14-16-medium sticky top-[0] z-[2] bg-white p-2">All Products</div>
      <div class="px-2 pb-2">
        <ProductCard v-for="(item, index) in products" :key="index" :data="item" />
        <Observer v-if="isFetchMore" @intersect="fetchProducts({ disableLoading: true })">
          <template #customChild>
            <ProductSkeletons />
          </template>
        </Observer>
        <Observer v-if="isFetchMoreQuery" @intersect="fetchProducts({ disableLoading: true })">
          <template #customChild>
            <ProductSkeletons />
          </template>
        </Observer>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$modal-height: 620px;
$message-height: 93px;
$search-bar-height: 72px;
$list-height-with-message: calc($modal-height - $message-height + $search-bar-height);
$list-height-without-message: calc($modal-height - $search-bar-height);
.product-list {
  height: $list-height-with-message;
  &.is-full-height {
    height: $list-height-without-message !important;
  }
}
</style>
